var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "accordion__item", on: { click: _vm.open } },
    [
      _c(
        "div",
        { class: ["accordion__item-question", { active: _vm.visible }] },
        [
          _c("span", {
            staticClass: "icon-toggle",
            class: { active: _vm.visible },
          }),
          _vm._v(" "),
          _vm._t("accordion-question"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "accordion" },
          on: {
            enter: _vm.start,
            "after-enter": _vm.end,
            "before-leave": _vm.start,
            "after-leave": _vm.end,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              staticClass: "accordion__item-answer",
            },
            [_vm._t("accordion-answer")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }